var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Modal, Text, Heading } from '@kiwicom/orbit-components/lib/';
import { P2 } from '../../UI-helpers/typography';
import { Button } from '@appspotr/ui-kit';
import { TextWrapper, LogoutContainer, LogoutButtonWrapper } from './styles';
var LogOutPopUp = /** @class */ (function (_super) {
    __extends(LogOutPopUp, _super);
    function LogOutPopUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisible: false,
        };
        _this.UIActions = {
            modal: {
                show: function () {
                    _this.setState({ isVisible: true });
                },
                hide: function () {
                    _this.setState({ isVisible: false });
                    _this.props.onHide();
                },
                onLogOut: function () {
                    _this.props.onLogOut();
                    _this.setState({ isVisible: false });
                    _this.props.onHide();
                },
            },
        };
        return _this;
    }
    LogOutPopUp.prototype.componentDidMount = function () {
        if (this.props.isVisible) {
            this.UIActions.modal.show();
        }
        else {
            this.UIActions.modal.hide();
        }
    };
    LogOutPopUp.prototype.componentDidUpdate = function (PrevProps) {
        if (PrevProps.isVisible !== this.props.isVisible) {
            if (this.props.isVisible) {
                this.UIActions.modal.show();
            }
            else {
                this.UIActions.modal.hide();
            }
        }
    };
    LogOutPopUp.prototype.render = function () {
        return this.state.isVisible ? (_jsx(Modal, __assign({ onClose: this.props.onHide }, { children: _jsxs(LogoutContainer, { children: [_jsx(Heading, __assign({ type: "title2" }, { children: "Are you sure you want to Sign Out of Appspotr?" })), _jsx(TextWrapper, { children: _jsx(Text, __assign({ align: "center" }, { children: _jsxs(P2, { children: ["You are about to sign out of Appspotr. Please confirm", _jsx("br", {}), " this action by clicking on Sign Out button."] }) })) }), _jsxs(LogoutButtonWrapper, { children: [_jsx(Button, __assign({ onClick: this.UIActions.modal.hide, style: { marginRight: 10, width: 150, justifyContent: 'center' }, type: "secondary" }, { children: "Cancel" })), _jsx(Button, __assign({ onClick: this.UIActions.modal.onLogOut, type: "primary", style: { marginLeft: 10, width: 150, justifyContent: 'center' } }, { children: "Sign Out" }))] })] }) }))) : null;
    };
    return LogOutPopUp;
}(React.Component));
export default LogOutPopUp;
